import { render } from "./SingleSKUCard.vue?vue&type=template&id=cc752df6&scoped=true&ts=true"
import script from "./SingleSKUCard.vue?vue&type=script&lang=ts"
export * from "./SingleSKUCard.vue?vue&type=script&lang=ts"

import "./SingleSKUCard.vue?vue&type=style&index=0&id=cc752df6&lang=scss&scoped=true"
import "./SingleSKUCard.vue?vue&type=style&index=1&id=cc752df6&lang=scss"

import exportComponent from "/var/jenkins_home/workspace/saas-pim-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cc752df6"]])

export default __exports__